import React from "react";

const NotificationsPage = () => {
    return(
        <div>
            <p>hola</p>
        </div>
    )
}

export default NotificationsPage;